import { render, staticRenderFns } from "./modalAddAppProduct.vue?vue&type=template&id=2397936e&"
import script from "./modalAddAppProduct.vue?vue&type=script&lang=js&"
export * from "./modalAddAppProduct.vue?vue&type=script&lang=js&"
import style0 from "./modalAddAppProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports